exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-containers[data-v-af540c1a]{display:flex;flex-wrap:wrap;flex-direction:row-reverse;margin-top:-8px}.left-side-button[data-v-af540c1a]{display:flex;flex-direction:row-reverse;margin-top:8px}.right-side-button[data-v-af540c1a]{flex-grow:1;text-align:right}.danger-button[data-v-af540c1a],.hide-btn-container[data-v-af540c1a]{margin-left:.5em}.right-side-button>button[data-v-af540c1a]{margin-top:8px}@media (max-width:650px){.button-containers[data-v-af540c1a]{display:block;text-align:center}.left-side-button[data-v-af540c1a]{display:block}.right-side-button[data-v-af540c1a]{text-align:center}.danger-button[data-v-af540c1a]{margin-left:0;margin-bottom:8px}}.edit-object-title[data-v-af540c1a]:before{content:\" - \"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af540c1a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ProfileSectionDialog.vue
// module id = 1026
// module chunks = 7